import {Component, OnInit, inject} from '@angular/core';
import {CdkScrollableModule} from '@angular/cdk/scrolling';
import {
  DragDropModule,
  CdkDragDrop,
  moveItemInArray,
} from '@angular/cdk/drag-drop';
import {MatButtonModule} from '@angular/material/button';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatIconModule} from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';
import {UserPreferenceService} from '../../../services/user-preference.service';
import {
  ColumnPreference,
  UserPreference,
} from '../../../models/user-preference';

@Component({
  selector: 'app-manage-columns-dropdown',
  templateUrl: './manage-columns-dropdown.component.html',
  styleUrls: ['./manage-columns-dropdown.component.scss'],
  standalone: true,
  imports: [
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    MatCheckboxModule,
    CdkScrollableModule,
    DragDropModule,
  ],
})
export class ManageColumnsDropdownComponent implements OnInit {
  private userPreferenceService = inject(UserPreferenceService);

  userPreference: UserPreference;

  ngOnInit(): void {
    this.userPreferenceService.userPreferences$.subscribe(
      (userPreferences) => (this.userPreference = userPreferences)
    );
  }

  savePreferences() {
    this.userPreferenceService.saveUserPreferences(this.userPreference);
  }

  checkAndUpdate(column: ColumnPreference) {
    column.hideColumn = !column.hideColumn;
    this.savePreferences();
  }

  drop(event: CdkDragDrop<ColumnPreference[]>) {
    moveItemInArray(
      this.userPreference?.caregiverDashboardColumns,
      event.previousIndex,
      event.currentIndex
    );
    this.savePreferences();
  }
}
